import Vue from "vue";
import VueEcho from "vue-echo-laravel";

window.Pusher = require('pusher-js');

Vue.use(VueEcho, {
    broadcaster: 'pusher',
    key: 'bauplan',
    wsHost: process.env.MIX_WS_HOST || window.location.hostname,
    wsPort: process.env.MIX_WS_PORT || 6001,
    wssPort: process.env.MIX_WSS_PORT || 6001,
    wsPath: process.env.MIX_WS_PATH,
    disableStats: true,
    encrypted: process.env.MIX_APP_ENV === 'production',
    enabledTransports: ['ws', 'wss'],
    auth: {
        headers: {

        }
    }
});
